import { useCallback, useState } from "react";

import { useDropzone } from "react-dropzone";
import { Grid, makeStyles, Typography, Box } from "@material-ui/core";

import { COLORS } from "../../../../../theme/colors";
import { putData } from "../../../../../services";
import endPoints from "../../../../../services/apiEndPoints";
import { TextButton, Image } from "../../../../../components/base";
import dragIcon from "../../../../../assets/images/icons/workspace/dragIcon.svg";
import uploadingAnimation from "../../../../../assets/JSON/uploadImage.json";
import JsonAnimation from "../../../../../components/base/JsonAnimation";

const useStyles = makeStyles((theme) => ({
  heading: {
    fontSize: 30,
    fontWeight: 700,
    textAlign: "center",
  },
  subHead: {
    fontSize: 18,
    fontWeight: 700,
  },
  outerBorder: {
    border: `2px dashed  ${COLORS.darks[0][25]}`,
    textAlign: "center",
    width: "100%",
  },
  uploadingText: {
    color: COLORS.purple,
    fontSize: 18,
    marginBottom: theme.spacing(5),
  },
  uploadedFileCountText: {
    color: COLORS.green,
    marginTop: 48,
    textAlign: "center",
  },
}));

export const UploadElectricityBills = ({ setLoading, onError, buildingId, uploadedBillFiles }) => {
  const classes = useStyles();
  const [uploading, setUploading] = useState(false);
  const [uploadedFileCount, setUploadedFileCount] = useState(uploadedBillFiles);
  const apiUrl = endPoints.OB_OPERATOR_ELECTRICITY_DATA.replace("{id}", buildingId);

  const onDrop = useCallback((files) => {
    if (!files.length) return;

    setLoading(true);
    setUploading(true);
    const formData = new FormData();
    for (const f of files) {
      formData.append("files", f);
    }

    putData(apiUrl, (data) => setUploadedFileCount(data.uploaded_bill_files), formData, {
      "Content-Type": "multipart/form-data",
    })
      .catch(onError)
      .finally(() => {
        setLoading(false);
        setUploading(false);
      });
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
      <Typography className={classes.heading}>Now for the fun part -</Typography>
      <Typography className={classes.heading}>
        Attach latest electricity supplier bills
        <span className={classes.subHead}>(last X months)</span>
      </Typography>
      <Box
        {...getRootProps()}
        className={classes.outerBorder}
        mt={5}
        justifyContent="center"
        display="flex"
      >
        <input {...getInputProps()} />
        {uploading ? (
          <Box className={classes.uploadTextcontainer}>
            <JsonAnimation
              animationData={uploadingAnimation}
              loop={true}
              height={300}
              width={300}
            />
            <Typography className={classes.uploadingText}>Uploading...</Typography>
          </Box>
        ) : (
          <Box py={14}>
            <Box display="flex" alignItems="center" mb={4}>
              <Typography variant="h3">Drag and drop files here or</Typography>
              <TextButton
                text=" Browse"
                textStyle={{ fontSize: 18, lineHeight: "24px", marginLeft: 2 }}
              />
            </Box>
            <Image src={dragIcon} width={200} height={72} />
            {uploadedFileCount > 0 && (
              <Typography className={classes.uploadedFileCountText}>
                {uploadedFileCount} file{uploadedFileCount !== 1 ? "s" : ""} uploaded
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Grid>
  );
};
